export const ExceptionInterceptorNoShowError: string[] = [
  "/carousel/templates/",
  "coderesbgonlinesbsbanners.azurewebsites.net",
  "login/web",
  "GetLastPrivacyPoliticsSelfieByRegion",
];
